/** 前端語系 */
export enum Locale {
  /** 英文 */
  EN = 'en',
  /** 繁體中文 */
  ZH_TW = 'zh-TW',
  /** 簡體中文 */
  ZH_CN = 'zh-CN'
}

/** API 語系 */
export enum ApiLocale {
  /** 英文 */
  EN = 'EN',
  /** 繁體中文 */
  ZH_TW = 'ZH',
  /** 簡體中文 */
  ZH_CN = 'CN'
}

/** EVA 網站語系 */
export enum EVALocale {
  /** 英文 */
  EN = 'en_US',
  /** 繁體中文 */
  ZH_TW = 'zh_TW',
  /** 簡體中文 */
  ZH_CN = 'zh_CN'
}

/** 語系所對應的 class */
export const LocaleClass: Record<Locale, string> = {
  /** 英文 */
  [Locale.EN]: 'en',
  /** 繁體中文 */
  [Locale.ZH_TW]: 'zh',
  /** 簡體中文 */
  [Locale.ZH_CN]: 'cn'
} as const

/** 前端語系 to API 語系 */
export const LocaleToApi: Record<Locale, ApiLocale> = {
  /** 英文 */
  [Locale.EN]: ApiLocale.EN,
  /** 繁體中文 */
  [Locale.ZH_TW]: ApiLocale.ZH_TW,
  /** 簡體中文 */
  [Locale.ZH_CN]: ApiLocale.ZH_CN
} as const

/** API 語系 to 前端語系 */
export const ApiToLocale: Record<ApiLocale, Locale> = {
  /** 英文 */
  [ApiLocale.EN]: Locale.EN,
  /** 繁體中文 */
  [ApiLocale.ZH_TW]: Locale.ZH_TW,
  /** 簡體中文 */
  [ApiLocale.ZH_CN]: Locale.ZH_CN
} as const

/** 長榮訂票平台語系 */
export enum EVABookingLocale {
  /** 英文 */
  EN = 'en-us',
  /** 繁體中文 */
  ZH_TW = 'zh-tw',
  /** 簡體中文 */
  ZH_CN = 'sc-cn'
}

/** 前端語系 to 長榮訂票平台語系 */
export const LocaleToEVABooking: Record<Locale, EVABookingLocale> = {
  /** 英文 */
  [Locale.EN]: EVABookingLocale.EN,
  /** 繁體中文 */
  [Locale.ZH_TW]: EVABookingLocale.ZH_TW,
  /** 簡體中文 */
  [Locale.ZH_CN]: EVABookingLocale.ZH_CN
} as const
